import { Component, Vue, Prop } from 'vue-property-decorator';
import icons from '../../../telstra-ui-resources/images/sprite.symbol.svg';

@Component
export default class Icon extends Vue {

  @Prop() name!: string;

  render(): JSX.Element {
    return (
      <use xlinkHref={`${icons}#${this.name}`}></use>
    );
  }

}
